var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "el-row",
        { staticStyle: { margin: "5px 0" } },
        [
          _vm.detailForm.status == "DRAFT" && _vm.operationType !== "view"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_TPL_MANAGE_MAINTAIN,
                      expression: "PROC_TPL_MANAGE_MAINTAIN",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onSave },
                },
                [_vm._v("保存")]
              )
            : _vm._e(),
          (_vm.detailForm.status == "DRAFT" ||
            _vm.detailForm.status == "ACTIVE") &&
          _vm.operationType !== "view"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_TPL_MANAGE_MAINTAIN,
                      expression: "PROC_TPL_MANAGE_MAINTAIN",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("提交")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "gri-info-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "line" }),
                _c("span", [_vm._v("GRI基本信息")]),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: {
                model: _vm.detailForm,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "模板编码", prop: "templateCode" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: "",
                              placeholder: "请输入模板编码",
                            },
                            model: {
                              value: _vm.detailForm.templateCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "templateCode", $$v)
                              },
                              expression: "detailForm.templateCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "模板名称", prop: "templateName" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.operationType == "view",
                              clearable: "",
                              maxlength: "50",
                              placeholder: "请输入模板名称",
                            },
                            model: {
                              value: _vm.detailForm.templateName,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "templateName", $$v)
                              },
                              expression: "detailForm.templateName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "版本号", prop: "templateVersion" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: "",
                              placeholder: "请输入版本号",
                            },
                            model: {
                              value: _vm.detailForm.templateVersion,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "templateVersion", $$v)
                              },
                              expression: "detailForm.templateVersion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主键配置", prop: "keyConfig" } },
                        [
                          _c("ic-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              table: "TT_PROC",
                              field: "TPL_KEY_CONFIG",
                              clearable: "",
                              disabled:
                                _vm.operationType == "view" ||
                                _vm.detailForm.templateVersion == 2,
                            },
                            model: {
                              value: _vm.detailForm.keyConfig,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "keyConfig", $$v)
                              },
                              expression: "detailForm.keyConfig",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "GRI编码", prop: "griCode" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请输入GRI编码",
                                disabled:
                                  _vm.operationType == "view" ||
                                  _vm.detailForm.templateVersion == 2,
                                readonly: "",
                              },
                              on: { click: _vm.showGriCodeDialog },
                              model: {
                                value: _vm.detailForm.griCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailForm,
                                    "griCode",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "detailForm.griCode",
                              },
                            },
                            [
                              _vm.operationType !== "view" &&
                              _vm.detailForm.templateVersion != 2
                                ? _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: { click: _vm.showGriCodeDialog },
                                    slot: "append",
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "GRI名称", prop: "griName" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { maxlength: "50", disabled: "" },
                            model: {
                              value: _vm.detailForm.griName,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "griName", $$v)
                              },
                              expression: "detailForm.griName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Category1", prop: "category1Name" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: "",
                              placeholder: "请输入模板编码",
                            },
                            model: {
                              value: _vm.detailForm.category1Name,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "category1Name", $$v)
                              },
                              expression: "detailForm.category1Name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Category2", prop: "category2Name" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: "",
                              placeholder: "请输入模板编码",
                            },
                            model: {
                              value: _vm.detailForm.category2Name,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "category2Name", $$v)
                              },
                              expression: "detailForm.category2Name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Category3", prop: "category3Name" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: "",
                              placeholder: "请输入模板编码",
                            },
                            model: {
                              value: _vm.detailForm.category3Name,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "category3Name", $$v)
                              },
                              expression: "detailForm.category3Name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型", prop: "templateType" } },
                        [
                          _c("ic-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              table: "TT_PROC_TEMPLATE",
                              field: "TPLTYPE",
                              clearable: "",
                              disabled:
                                _vm.operationType == "view" ||
                                _vm.detailForm.templateVersion == 2,
                            },
                            on: { change: _vm.onChangeTemplateType },
                            model: {
                              value: _vm.detailForm.templateType,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "templateType", $$v)
                              },
                              expression: "detailForm.templateType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "生成品评报告",
                            prop: "generateSensoryReport",
                          },
                        },
                        [
                          _c("ic-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              table: "COMMON",
                              field: "YES_NO_BOOLEAN",
                              clearable: "",
                              disabled:
                                _vm.operationType == "view" ||
                                _vm.detailForm.templateType != "S",
                            },
                            model: {
                              value: _vm.detailForm.generateSensoryReport,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.detailForm,
                                  "generateSensoryReport",
                                  $$v
                                )
                              },
                              expression: "detailForm.generateSensoryReport",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c("ic-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              table: "TT_PROC_TEMPLATE",
                              field: "STATUS",
                              disabled: "",
                              placeholder: "请选择",
                            },
                            model: {
                              value: _vm.detailForm.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "status", $$v)
                              },
                              expression: "detailForm.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "描述", prop: "comments" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              maxlength: "100",
                              autosize: "",
                              disabled: _vm.operationType == "view",
                              clearable: "",
                            },
                            model: {
                              value: _vm.detailForm.comments,
                              callback: function ($$v) {
                                _vm.$set(_vm.detailForm, "comments", $$v)
                              },
                              expression: "detailForm.comments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          key: _vm.refreshKey,
          staticClass: "process-config-card",
          attrs: { shadow: "never" },
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "line" }),
                _c("span", [_vm._v("制成配置")]),
              ]),
              _c(
                "div",
                { staticClass: "title_button" },
                [
                  _vm.operationType !== "view"
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.PROC_TPL_MANAGE_MAINTAIN,
                              expression: "PROC_TPL_MANAGE_MAINTAIN",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.onAddProcess },
                        },
                        [_vm._v("添加制成")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.PROC_TPL_MANAGE_MAINTAIN,
                          expression: "PROC_TPL_MANAGE_MAINTAIN",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-sort",
                        disabled:
                          !_vm.detailForm.processes ||
                          _vm.detailForm.processes.length == 0,
                      },
                      on: { click: _vm.onSortProcess },
                    },
                    [_vm._v("制成排序")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.PROC_TPL_MANAGE_MAINTAIN,
                          expression: "PROC_TPL_MANAGE_MAINTAIN",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-setting",
                        disabled:
                          !_vm.detailForm.processes ||
                          _vm.detailForm.processes.length == 0,
                      },
                      on: { click: _vm.onConfigSheet },
                    },
                    [_vm._v("配置Excel模板")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm.detailForm.processes.length > 0
            ? _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "process-tabs",
                      attrs: {
                        closable: _vm.operationType !== "view",
                        type: "border-card",
                      },
                      on: {
                        "tab-remove": _vm.handleRemoveProcess,
                        "tab-click": _vm.handleTabClick,
                      },
                      model: {
                        value: _vm.activeProcessTab,
                        callback: function ($$v) {
                          _vm.activeProcessTab = $$v
                        },
                        expression: "activeProcessTab",
                      },
                    },
                    _vm._l(
                      _vm.detailForm.processes,
                      function (process, processIndex) {
                        return _c(
                          "el-tab-pane",
                          {
                            key: process.tplProcessId,
                            attrs: {
                              label: process.processName,
                              name: processIndex.toString(),
                            },
                          },
                          _vm._l(
                            process.factors,
                            function (indicator, indicatorIndex) {
                              return _c(
                                "div",
                                {
                                  key: indicator.tplFactorId,
                                  staticClass: "indicator_container",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "indicator_item" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(indicator.factorName)),
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "30px",
                                            "font-weight": "normal",
                                            "font-size": "12px",
                                            "text-decoration": "underline",
                                            color: "#f8ab01",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "输入模式:" +
                                              _vm._s(indicator.inputModeText)
                                          ),
                                        ]
                                      ),
                                      _vm.operationType !== "view"
                                        ? _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "acl",
                                                  rawName: "v-acl",
                                                  value:
                                                    _vm.PROC_TPL_MANAGE_MAINTAIN,
                                                  expression:
                                                    "PROC_TPL_MANAGE_MAINTAIN",
                                                },
                                              ],
                                              staticStyle: {
                                                position: "absolute",
                                                right: "15px",
                                              },
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteProcess(
                                                    process.factors,
                                                    indicatorIndex
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  indicator.inputMode == "TABLE"
                                    ? _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                                icon: "el-icon-view",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onView(
                                                    process,
                                                    indicator
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("查看")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-tabs",
                                    {
                                      staticClass: "indicator-tabs",
                                      attrs: { type: "border-card" },
                                      on: {
                                        "tab-click": function ($event) {
                                          return _vm.handleIndicatorTabClick(
                                            process,
                                            indicator,
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: indicator.activeTab,
                                        callback: function ($$v) {
                                          _vm.$set(indicator, "activeTab", $$v)
                                        },
                                        expression: "indicator.activeTab",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "参数列表",
                                            name: "params",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: indicator.paramsLists,
                                                "max-height": "425",
                                                border: "",
                                                stripe: "",
                                              },
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "paramCode",
                                                  label: "参数编码",
                                                  "min-width": "120",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "paramName",
                                                  label: "参数名称",
                                                  "min-width": "150",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "dataType",
                                                  label: "数据类型",
                                                  "min-width": "100",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c(
                                                            "el-tag",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm.setTagColor(
                                                                    scope.row
                                                                      .dataType
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.setDataType(
                                                                      scope.row
                                                                        .dataType
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "uom",
                                                  label: "单位",
                                                  "min-width": "80",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "控制维度绑定",
                                                  "min-width": "100",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "primary",
                                                                size: "mini",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onSetControl(
                                                                      process,
                                                                      indicator,
                                                                      scope.row,
                                                                      scope.$index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("设置")]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "required",
                                                  label: "必填",
                                                  "min-width": "100",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c(
                                                            "el-tag",
                                                            {
                                                              attrs: {
                                                                type: scope.row
                                                                  .required
                                                                  ? "success"
                                                                  : "info",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    scope.row
                                                                      .required
                                                                      ? "是"
                                                                      : "否"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "supplierViewable",
                                                  label: "供应商可见",
                                                  "min-width": "100",
                                                  "show-overflow-tooltip": "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-switch", {
                                                            attrs: {
                                                              "active-color":
                                                                "#13ce66",
                                                              "inactive-color":
                                                                "#ff4949",
                                                              disabled:
                                                                _vm.operationType ==
                                                                "view",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .supplierViewable,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "supplierViewable",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.supplierViewable",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "paramDesc",
                                                  label: "参数描述",
                                                  "min-width": "180",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "standard",
                                                  label: "标准值",
                                                  "min-width": "150",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "lineBreak",
                                                  label: "是否换行显示",
                                                  "min-width": "100",
                                                  "show-overflow-tooltip": "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-switch", {
                                                            attrs: {
                                                              "active-color":
                                                                "#13ce66",
                                                              "inactive-color":
                                                                "#ff4949",
                                                              disabled:
                                                                _vm.operationType ==
                                                                "view",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .lineBreak,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "lineBreak",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.lineBreak",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "category",
                                                  label: "所属分组",
                                                  "min-width": "130",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.operationType ==
                                                                "view",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .category,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "category",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.category",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm.operationType !== "view"
                                                ? _c("el-table-column", {
                                                    attrs: {
                                                      label: "操作",
                                                      width: "290",
                                                      fixed: "right",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "primary",
                                                                    size: "mini",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleSetStandard(
                                                                          process,
                                                                          indicator,
                                                                          scope.row,
                                                                          "params",
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "设置标准"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm.operationType !==
                                                              "view"
                                                                ? _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        type: "primary",
                                                                        size: "mini",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onSetRangeValue(
                                                                              process,
                                                                              indicator,
                                                                              scope.row,
                                                                              scope.$index
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "规格容差配置"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "danger",
                                                                    size: "mini",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.deleteProcessParam(
                                                                          indicator,
                                                                          scope.row,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("删除")]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "统计参数",
                                            name: "statistics",
                                          },
                                        },
                                        [
                                          _vm.operationType !== "view"
                                            ? _c(
                                                "el-row",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "10px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini",
                                                        icon: "el-icon-plus",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onAddParam(
                                                            process,
                                                            indicator
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("新增")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: indicator.statisticsParams,
                                                "max-height": "425",
                                                border: "",
                                                stripe: "",
                                              },
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "paramCode",
                                                  label: "参数编码",
                                                  "min-width": "120",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "paramName",
                                                  label: "参数名称",
                                                  "min-width": "150",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "dataType",
                                                  label: "数据类型",
                                                  "min-width": "100",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c(
                                                            "el-tag",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm.setTagColor(
                                                                    scope.row
                                                                      .dataType
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.setDataType(
                                                                      scope.row
                                                                        .dataType
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "uom",
                                                  label: "单位",
                                                  "min-width": "100",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "supplierViewable",
                                                  label: "供应商可见",
                                                  "min-width": "100",
                                                  "show-overflow-tooltip": "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row
                                                                  .supplierViewable
                                                                  ? "是"
                                                                  : "否"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "paramDesc",
                                                  label: "参数描述",
                                                  "min-width": "100",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "statsType",
                                                  label: "统计类型",
                                                  "min-width": "100",
                                                  "show-overflow-tooltip": "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("ic")(
                                                                scope.row
                                                                  .statsType,
                                                                "TT_PROC",
                                                                "STATISTIC_TYPE"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "standard",
                                                  label: "标准值",
                                                  "min-width": "150",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "lineBreak",
                                                  label: "是否换行显示",
                                                  "min-width": "150",
                                                  "show-overflow-tooltip": "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row
                                                                  .lineBreak
                                                                  ? "是"
                                                                  : "否"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "category",
                                                  label: "所属分组",
                                                  "min-width": "150",
                                                  "show-overflow-tooltip": "",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "操作",
                                                  width: "250",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _vm.operationType !==
                                                          "view"
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "primary",
                                                                    size: "mini",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onEdit(
                                                                          process,
                                                                          indicator,
                                                                          scope.row,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("编辑")]
                                                              )
                                                            : _vm._e(),
                                                          _vm.operationType ==
                                                          "view"
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "primary",
                                                                    size: "mini",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onViewS(
                                                                          process,
                                                                          indicator,
                                                                          scope.row,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("查看")]
                                                              )
                                                            : _vm._e(),
                                                          _vm.operationType !==
                                                          "view"
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "primary",
                                                                    size: "mini",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onSetStandard(
                                                                          process,
                                                                          indicator,
                                                                          scope.row,
                                                                          "statistics",
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "设置标准"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm.operationType !==
                                                          "view"
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "primary",
                                                                    size: "mini",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onDel(
                                                                          process,
                                                                          indicator,
                                                                          scope.row,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("删除")]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "参数排序",
                                            name: "sort",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              key:
                                                indicator.tplFactorId +
                                                _vm.refreshKey,
                                              ref: `sortableTable_${indicator.tplFactorId}`,
                                              refInFor: true,
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: indicator.sortData,
                                                border: "",
                                                "row-key": "id",
                                              },
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "序号",
                                                  prop: "sortIndex",
                                                  width: "80",
                                                },
                                              }),
                                              _vm.operationType !== "view"
                                                ? _c("el-table-column", {
                                                    attrs: {
                                                      label: "拖拽排序",
                                                      width: "80",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-grip-vertical drag-handle el-icon-rank",
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  })
                                                : _vm._e(),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "code",
                                                  label: "参数编码",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "name",
                                                  label: "参数名称",
                                                },
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "paramTypeText",
                                                  label: "参数类型",
                                                },
                                              }),
                                              _vm.operationType !== "view"
                                                ? _c("el-table-column", {
                                                    attrs: {
                                                      label: "操作",
                                                      width: "180",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "primary",
                                                                    icon: "el-icon-top",
                                                                    size: "mini",
                                                                    disabled:
                                                                      scope.$index ===
                                                                      0,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.moveUp(
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("升序")]
                                                              ),
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "primary",
                                                                    icon: "el-icon-bottom",
                                                                    size: "mini",
                                                                    disabled:
                                                                      scope.$index ===
                                                                      indicator
                                                                        .sortData
                                                                        .length -
                                                                        1,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.moveDown(
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("降序")]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("el-divider"),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-backtop",
        {
          attrs: {
            target: ".content",
            bottom: 100,
            "visibility-height": 100,
            right: 20,
          },
        },
        [
          _c(
            "div",
            {
              style: {
                height: "100%",
                width: "100%",
                backgroundColor: "transparent",
                textAlign: "center",
                lineHeight: "40px",
                color: "#1989fa",
              },
            },
            [
              _c("img", {
                staticStyle: {
                  "max-width": "100%",
                  "max-height": "100%",
                  "object-fit": "contain",
                },
                attrs: { src: require("@/assets/img/backTop.svg"), alt: "" },
              }),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: "新增制成",
            visible: _vm.processDialogVisible,
            width: "90%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.processDialogVisible = $event
            },
            close: _vm.onCloseProcessDialog,
          },
        },
        [
          _c("processDialog", {
            attrs: { processSelected: _vm.processSelected, isDialog: true },
            on: {
              addProcess: _vm.addProcess,
              onCancelProcess: _vm.onCloseProcessDialog,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: "参数标准值设置",
            visible: _vm.paramStandardVisible,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.paramStandardVisible = $event
            },
            close: _vm.onCloseParamStandardDialog,
          },
        },
        [
          _c("paramStandardDialog", {
            attrs: {
              standardFormConfig: _vm.standardFormConfig,
              currentStandardParamConfig: _vm.currentStandardParamConfig,
            },
            on: {
              handleSaveStandardConfig: _vm.handleSaveStandardConfig,
              onCloseParamStandardDialog: _vm.onCloseParamStandardDialog,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: _vm.multiTitle,
            visible: _vm.multiValuesDialogVisible,
            width: "90%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.multiValuesDialogVisible = $event
            },
            close: _vm.onCloseMultiValuesDialog,
          },
        },
        [
          _c("previewDialog", {
            attrs: {
              previewMultiLists: _vm.previewMultiLists,
              previewColumns: _vm.previewColumns,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: "GRI",
            visible: _vm.griDialogVisible,
            width: "90%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.griDialogVisible = $event
            },
            close: _vm.onCloseGriDialog,
          },
        },
        [
          _c("griDialog", {
            on: {
              onConfirmGri: _vm.onConfirmGri,
              onCloseGri: _vm.onCloseGriDialog,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.addStatisticsParamVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addStatisticsParamVisible = $event
            },
            close: _vm.onCloseParamDialog,
          },
        },
        [
          _c("statisticsConfig", {
            ref: "statisticsConfig",
            attrs: {
              operationType: _vm.operationType,
              paramNameLists: _vm.paramNameLists,
              curForm: _vm.curForm,
            },
            on: {
              handleSaveStatisticsConfig: _vm.handleSaveStatisticsConfig,
              onCancelStatistics: _vm.onCloseParamDialog,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: "制成排序",
            visible: _vm.sortDialogVisible,
            width: "50%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sortDialogVisible = $event
            },
            close: _vm.onCloseSortDialog,
          },
        },
        [
          _c("sortDialog", {
            attrs: {
              isParamsDialog: _vm.isParamsDialog,
              operationType: _vm.operationType,
              sortData: _vm.sortLists,
            },
            on: { setSort: _vm.setSort, onCancelSort: _vm.onCloseSortDialog },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: "导入Excel模板配置",
            visible: _vm.sheetDialogVisible,
            width: "70%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sheetDialogVisible = $event
            },
            close: _vm.onCloseSheetDialog,
          },
        },
        [
          _c("sheetDialog", {
            attrs: {
              sheetData: _vm.sheetData,
              operationType: _vm.operationType,
            },
            on: {
              setSheetSort: _vm.setSheetSort,
              cancelSheetSort: _vm.onCloseSheetDialog,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: "配置控制维度",
            visible: _vm.controlDialogVisible,
            width: "400px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.controlDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "controlFormRef",
              attrs: { model: _vm.controlForm, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "请选择该参数控制的制成（可多选）：" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { disabled: _vm.operationType == "view" },
                      model: {
                        value: _vm.controlForm.dataList,
                        callback: function ($$v) {
                          _vm.$set(_vm.controlForm, "dataList", $$v)
                        },
                        expression: "controlForm.dataList",
                      },
                    },
                    _vm._l(_vm.controlProcessList, function (item) {
                      return _c(
                        "el-checkbox",
                        {
                          key: item.processCode,
                          attrs: { label: item.processCode },
                        },
                        [_vm._v(" " + _vm._s(item.processName) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.operationType !== "view"
            ? _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: { type: "flex", justify: "center", align: "middle" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          _vm.controlDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.confirmControl },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "process_dialog",
          attrs: {
            title: "规格容差配置规则",
            visible: _vm.rangeDialogVisible,
            width: "400px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.rangeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "rangeFormRef", attrs: { model: _vm.rangeForm } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "请选择类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.rangeForm.toleranceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.rangeForm, "toleranceType", $$v)
                        },
                        expression: "rangeForm.toleranceType",
                      },
                    },
                    _vm._l(_vm.rangeValueDict, function (item) {
                      return _c("el-radio", { attrs: { label: item.code } }, [
                        _vm._v(_vm._s(item.value)),
                      ])
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "控制范围" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "70%" },
                    model: {
                      value: _vm.rangeForm.tolerance,
                      callback: function ($$v) {
                        _vm.$set(_vm.rangeForm, "tolerance", $$v)
                      },
                      expression: "rangeForm.tolerance",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-bottom": "15px" },
              attrs: { type: "flex", justify: "center", align: "middle" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.rangeDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.confirmRangeValue },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }